import * as R from 'ramda'
import { t } from 'i18next'
import { Offer, Opportunity, ClientFrontlineConfig, Building, OpportunityBuilding, EquipmentPriceAndDetails, OverviewGroupDetails } from 'app/types/types'
import { getCommercialTermsErrors } from '../nemo/offer'
// import { CurrentOffer } from '../../state/current-offer'
// import { setCommercialTerm } from '../../nemo/offer/commercial-terms'
// import { enableEscalationOffer, resetEscalationOffer } from '../../nemo/offering/recommendation'
// import { CommercialTermKey } from 'nemo-pricing'
// import { FrontlineConfig } from '../../state/frontline-config'
// import { getUpdatedOfferFields } from '../../nemo/offer/reset'
// import { getEquipmentForOffer } from '../../../../common/contract-utils'
// import { getEquipmentType } from '../../../../common/common-utils'
// import { getEquipmentDataFromPreviousContract } from '../../../../common/offer'
// import { formatPrice } from '../nemo/pricing/utils'
// import { round } from '../../../../common/prices'
// import { resetGroups, updateAssessmentMethod } from '../../nemo/offer/assessment-selection'
// import { PriceScoper, priceEstimationScoper } from '../OfferWizard/Price/priceScoper'
// import { resetEscalationFlowOfferPriceEstimation, setOfferPriceEstimation } from '../nemo/offer/price-estimation'
// import { resetSelectedInteractionRating, setInteractionScope } from '../nemo/offer/interaction-scope'

// import { setTotalDiscountPercentage } from '../OfferWizard/Price/discount'
// import { getAssessmentProgress } from '../nemo/assessment/assessment-progress'
import { Offering } from '../nemo/offering/types'
import { round } from 'app/app/common/prices'
import { getEquipmentType } from 'app/app/common/common-utils'
import { getOpportunityValidationErrors } from './prepare-utils'
import { resetOfferPriceEstimation } from '../nemo/offer/price-estimation'

// Escalation flow gets enabled only if it satisfies the following
// - Only One Active contract
// - Opportunity should be Renegotiation or SDB Renegotiation
// - Annual Contract value and annual price should be more than 0
// - Document type should be 'YWV'
// - Option C or Option AC is set in MBS Renego princing model
// - Standard Assessment is deactivated for this Frontline in MBS
// - Consolidated total of all equipment should be same as contract annualValue
// - Previous tenders created should not have a standard assessment
// - Contract type is one of these ["06","07","08","11","12","13","14","15"]
export function isEscalationFlowEnabled(
  offer: Offer,
  frontlineConfig: ClientFrontlineConfig,
  excludeEquipmentMatching: boolean = false
) {
  const escalationContractTypeCode = ['06', '07', '08', '11', '12', '13', '14', '15', '20', '21', '22', '23', '24']
  const { opportunity, isEquipmentEnabledInOffer, contractEquipmentsTotalAnnualValue } = offer
  const { contracts } = opportunity
  const contract = contracts ? R.head(contracts) : null
  if (contract) {
    return (
      contracts &&
      contracts.length === 1 &&
      !contract.expired &&
      isRenegotiationTypeOppCategory(offer) &&
      escalationContractTypeCode.includes(contract.contractType) &&
      escalationContractTypeCode.includes(contract.rushContractTypeCode) &&
      contract.annualContractValue > 0 &&
      contract.documentType === 'YWV' &&
      (frontlineConfig.renegotiation_refresh?.some(model => model.renegoModel === 'optionC' && model.selected === true) ?? false) &&
      (excludeEquipmentMatching || doesOfferHasSameNoOfEquipment(offer)) &&
      round(contract.annualContractValue) === round(contractEquipmentsTotalAnnualValue || 0) &&
      !frontlineConfig.enabledAssessmentMethod.includes('standard') &&
      !previousVersionStandardOfferExists(offer) &&
      isEquipmentEnabledInOffer
    )
  }
  return false
}

export function isEscalationActiveAndEnabled(offer: Offer, frontlineConfig: ClientFrontlineConfig): boolean {
  return !!(offer.isEscalationFlow?.active && isEscalationFlowEnabled(offer, frontlineConfig))
}

export function isEquipmentEnabled(offer: Offer, frontlineConfig: ClientFrontlineConfig) {
  const frontlineEquipmentType = frontlineConfig.enabledEquipment.map(equipCode => getEquipmentType(equipCode))
  const { buildings } = offer.opportunity
  const equipmentInOpportunity = R.chain(building => building.equipment.map(e => e.equipmentCategory), buildings)
  return (
    R.uniq(equipmentInOpportunity).filter(equipmentType => frontlineEquipmentType.includes(equipmentType)).length ===
    R.uniq(equipmentInOpportunity).length
  )
}

function previousVersionStandardOfferExists(offer: Offer) {
  return offer.previousVersions.some(version => version.assessmentMethod === 'standard') || false
}

export function getNumberOfEquipmentsInOpportunity(opportunity: Opportunity) {
  const { buildings } = opportunity
  return R.chain(building => building.equipment.filter(e => e.equipmentCategory), buildings).length
}

export function getNumberOfEquipmentsInOffer(buildings: Building[]) {
  return R.chain(building => building.details.equipment.filter(e => e.equipmentCategory), buildings).length
}

/*
export function getContractEquipmentsTotalAnnualValue(offer: Offer) {
  const equipmentList = getEquipmentForOffer(offer)
  const offerings = equipmentList.map(e => getEquipmentDataFromPreviousContract(offer, e.id))
  return offerings.reduce(
    (totalAnnualValue, equipment) =>
      totalAnnualValue + (equipment && equipment.annualValue ? equipment.annualValue : 0),
    0
  )
}


export function resetEscalationFlowOffer(offer: Offer) {
  const { opportunity } = offer
  const frontlineConfig = FrontlineConfig.get()

  CurrentOffer.update(_offer => R.merge(_offer, getUpdatedOfferFields(offer, frontlineConfig)))
  if (opportunity && opportunity.contracts) {
    const contract = R.head(opportunity.contracts)
    if (contract) {
      CurrentOffer.update(
        R.pipe(
          enableEscalationOffer('active', false),
          enableEscalationOffer('rushContractType', ''),
          enableEscalationOffer('numberOfEquipments', 0),
          resetSelectedInteractionRating(frontlineConfig)
        )
      )
    }
  }
  updateVasDiscountEquipmentPrice(0, offer.prices)
  setEscalationFlowOffer('escalationVasDiscountedPrices', 0)
  setEscalationFlowOffer('escalationVasDiscountedPercentage', 0)
  CurrentOffer.update(resetEscalationOffer())
  return CurrentOffer.get()
}


export function updateEscalationFlowOffer(offer: Offer) {
  const { opportunity, isEscalationFlow } = offer
  const frontlineConfig = FrontlineConfig.get()
  if (offer.assessmentMethod === 'standard') {
    updateAssessmentMethod(opportunity.id, 'grouped', frontlineConfig, false)
  }
  setOfferPriceEstimation(offer)
  CurrentOffer.update(_offer => R.merge(_offer, getUpdatedOfferFields(offer, frontlineConfig)))
  if (opportunity && opportunity.contracts) {
    const contract = R.head(opportunity.contracts)
    if (contract) {
      CurrentOffer.update(
        R.pipe(
          enableEscalationOffer('active', true),
          enableEscalationOffer('rushContractType', contract.rushContractTypeCode),
          enableEscalationOffer('numberOfEquipments', contract.numberOfEquipments)
        )
      )
      if (isEscalationWithVasAddendumOffer(undefined, true)) {
        hasMoreGroups(offer) && resetGroups(true)
        if (R.isEmpty(offer.interaction) || offer.selectedInteractionRating !== 'value_added_services_addendum') {
          CurrentOffer.update(
            R.pipe(setInteractionScope('value_added_services_addendum' as InteractionScope, frontlineConfig))
          )
        }
      }
      CurrentOffer.update(
        R.pipe(
          setCommercialTerm('VKBUR', contract.salesOffice),
          setCommercialTerm('VKGRP', contract.salesGroup),
          setCommercialTerm('ZTERM', contract.paymentTerm),
          setCommercialTerm('AUGRU', contract.orderReason ? contract.orderReason : '0'),
          setCommercialTerm('VKUESCH', contract.cancellationProcedure)
        )
      )
      if (!isEscalationFlow.active) {
        CurrentOffer.update(
          (currentOffer: Offer): Offer => ({
            ...currentOffer,
            isContractStartDateAtEquipmentLevel: false,
            isBillingPlanAtEquipmentLevel: false,
            isOrderReasonAtEquipmentLevel: false,
            priceEstimation: []
          })
        )
      }
    }
  }
}

export const updateVasDiscountEquipmentPrice = (
  editedVasAnnualPercentage: number,
  offerPrices: Price[],
  onlyPriceUpdate: boolean = false
) => {
  const prices = onlyPriceUpdate ? offerPrices : [...setTotalDiscountPercentage(editedVasAnnualPercentage, offerPrices)]
  CurrentOffer.update(
    (currentOffer: Offer): Offer => ({
      ...currentOffer,
      prices
    })
  )
}


export const getEscalationFlowEquipmentPrice = (
  equipmentId: string | null,
  offer: Offer,
  language: string,
  currency: string
) => {
  try {
    if (equipmentId) {
      const { isEscalationFlow } = offer
      const equipmentContractData = getEquipmentDataFromPreviousContract(offer, equipmentId)
      if (equipmentContractData && equipmentContractData.annualValue) {
        const price =
          equipmentContractData.annualValue +
          (equipmentContractData.annualValue * isEscalationFlow.escalatedPercentage) / 100
        return formatPrice(price, language, currency)
      }
    }
    return ''
  } catch (e) {
    return ''
  }
}


export function setEscalationFlowCommercialTerm(key: CommercialTermKey, value: string) {
  CurrentOffer.update(setCommercialTerm(key, value))
}

export function setEscalationFlowOffer(key: string, value: any) {
  CurrentOffer.update(enableEscalationOffer(key, value))
}

export function resetEscalationPriceEstimation() {
  CurrentOffer.update(resetEscalationFlowOfferPriceEstimation)
}

*/

export function getEscalationVatPrice(annualPrice: number, vat: number) {
  return round(annualPrice * ((100 + vat) / 100) - annualPrice)
}

// Equipment price during smart flow: contract annual value escalated by the offer's escalated percentage,
// not the regular grouped/discounted price (which ignores the contract-based escalation)
export function getEscalationFlowEquipmentPrice(offer: Offer, equipmentId: string): number {
  const equipmentContractData = getEquipmentDataFromPreviousContract(offer, equipmentId)
  if (!equipmentContractData || !equipmentContractData.annualValue) {
    return 0
  }
  const { escalatedPercentage } = offer.isEscalationFlow
  return round(equipmentContractData.annualValue + (equipmentContractData.annualValue * escalatedPercentage) / 100)
}

export function doesOfferHasSameNoOfEquipment(offer: Offer): boolean {
  const {
    opportunity: { contracts },
    equipmentsInOpportunity,
    buildings
  } = offer
  const contract = contracts ? R.head(contracts) : null

  // Basic count validation
  const countMatches = (
    contract != null &&
    equipmentsInOpportunity === contract.numberOfEquipments &&
    getNumberOfEquipmentsInOffer(buildings) === contract.numberOfEquipments
  )

  if (!countMatches) {
    return false
  }

  // Additional validation: ALL equipment must be from contract (not manually added)
  // This prevents smart flow when user adds manual equipment alongside CRM equipment
  return allEquipmentFromContract(offer)
}

// Validate that ALL equipment in offer came from contract (not manually created)
export function allEquipmentFromContract(offer: Offer): boolean {
  const contract = R.head(offer.opportunity.contracts || [])
  if (!contract || !contract.buildings) {
    return false
  }

  // Get all equipment IDs from contract using Ramda chain (flatMap)
  const contractEquipmentIds = new Set<string>(
    R.chain(
      building => R.chain(
        equipment => equipment.id ? [equipment.id] : [],
        Object.values(building)
      ),
      Object.values(contract.buildings)
    )
  )

  // Get all equipment from offer
  const allEquipmentInOffer = R.chain(
    building => building.details.equipment,
    offer.buildings
  )

  // Every equipment must have an ID that exists in contract
  return allEquipmentInOffer.every(
    equipment => equipment.id && contractEquipmentIds.has(equipment.id)
  )
}

export function isRenegotiationTypeOppCategory(offer: Offer): boolean {
  // Note: 'SDB Renegotiation' removed as doors are not supported in new app
  const escalationOpportunityCategories = ['Renegotiation']
  const {
    opportunity: { opportunityCategory }
  } = offer
  return escalationOpportunityCategories.includes(opportunityCategory)
}

/*
export function getEquipmentCountChanges(
  opportunity: Opportunity,
  buildings: Building[],
  offer: Offer,
  frontlineConfig: ClientFrontlineConfig
) {
  return {
    equipmentsInOpportunity: getNumberOfEquipmentsInOpportunity(opportunity),
    equipmentsInOffer: getNumberOfEquipmentsInOffer(buildings),
    isEquipmentEnabledInOffer: isEquipmentEnabled(offer, frontlineConfig),
    contractEquipmentsTotalAnnualValue: getContractEquipmentsTotalAnnualValue(offer)
  }
}


export function savePriceEstimation(newPrices: ReadonlyArray<PriceEstimation>) {
  const priceScoper = PriceScoper(false)
  const annualPriceEstimations = newPrices.map(priceEstimationScoper(priceScoper.unscope))
  CurrentOffer.update((offer: Offer) => ({ ...offer, priceEstimation: annualPriceEstimations }))
}

export const isEscalationWithVasAddendumOffer = (
  offer: Offer | undefined = CurrentOffer.get(),
  isGroupCreation: boolean = false
) => {
  const frontlineConfig = FrontlineConfig.get()
  const contract = offer.opportunity.contracts ? R.head(offer.opportunity.contracts) : null
  if (!frontlineConfig || !contract) {
    return false
  }
  // VAS addendum not enabled for escalation flow
  return false
}

*/

export const isOnlyElevatorOpportunity = (buildings: OpportunityBuilding[]) =>
  R.chain(
    building => building.equipment.filter(e => e.equipmentCategory === 'escalator'),
    buildings
  ).length === 0

export const numberOfEscalationWizardPages = {
  totalPagesWithEscalationVasAddendum: 4,
  totalPagesWithoutEscalationVasAddendum: 2
}

export const hasMultipleGroupsInOffering = (offering: Offering) => {
  const groupCount = offering && 'groups' in offering ? R.keys(offering.groups).length : 0
  return groupCount > 1
}

// Calculate total annual value from contract equipment
export function getContractEquipmentsTotalAnnualValue(offer: Offer): number {
  const contract = R.head(offer.opportunity.contracts || [])
  if (!contract || !contract.allContractLineItems) {
    return 0
  }

  return contract.allContractLineItems.reduce(
    (total, equipment) => total + (equipment.annualValue || 0),
    0
  )
}

// Get equipment data from previous contract
export function getEquipmentDataFromPreviousContract(
  offer: Offer,
  equipmentId: string
): any | null {
  const contract = R.head(offer.opportunity.contracts || [])
  if (!contract || !contract.buildings) {
    return null
  }

  // Search through all buildings and equipment in contract
  for (const building of Object.values(contract.buildings)) {
    for (const equipment of Object.values(building)) {
      if (equipment.id === equipmentId) {
        return equipment
      }
    }
  }
  return null
}

// Calculate finalized total price with VAT
// Matches old app logic: CreateEscalationTender.tsx lines 123-125
export function calculateFinalizedTotalPrice(
  annualPrice: number,
  commercialTerms: any
): number {
  const safeCommercialTerms = commercialTerms ?? {}
  const vat1 = parseFloat(safeCommercialTerms.VAT || '0')
  const vat2 = parseFloat(safeCommercialTerms.VAT_2 || '0')
  const vat3 = parseFloat(safeCommercialTerms.VAT_3 || '0')

  const totalVat =
    getEscalationVatPrice(annualPrice, vat1) +
    getEscalationVatPrice(annualPrice, vat2) +
    getEscalationVatPrice(annualPrice, vat3)

  return round(annualPrice + totalVat)
}

// Calculate escalated equipment prices
export function calculateEscalatedEquipmentPrices(
  offer: Offer,
  escalatedPercentage: number
): any[] {
  return offer.prices.map(price => {
    const equipmentContract = getEquipmentDataFromPreviousContract(offer, price.equipmentProfile.id)
    if (!equipmentContract) {
      return price
    }

    // Guard against undefined or null annualValue
    const baseAnnualValue = equipmentContract.annualValue || 0
    const newAnnualPrice = baseAnnualValue + (baseAnnualValue * escalatedPercentage / 100)

    return {
      ...price,
      annualSalesPrice: newAnnualPrice,
      discountedPrice: newAnnualPrice,
      totalAnnualSalesPrice: newAnnualPrice,
      totalDiscountedPrice: newAnnualPrice
    }
  })
}

// Populate commercial terms from contract
export function populateCommercialTermsFromContract(
  offer: Offer
): any {
  const contract = R.head(offer.opportunity.contracts || [])
  if (!contract) {
    return offer.commercialTerms
  }

  return {
    ...offer.commercialTerms,
    VKBUR: contract.salesOffice,
    VKGRP: contract.salesGroup,
    ZTERM: contract.paymentTerm,
    AUGRU: contract.orderReason || '0',
    VKUESCH: contract.cancellationProcedure
  }
}

// Pre-flight validation: Check if contract has all required data for escalation
// This prevents starting escalation flow with incomplete contract data
export function validateContractDataForEscalation(
  offer: Offer
): { isValid: boolean; missingFields: string[] } {
  const contract = R.head(offer.opportunity.contracts || [])
  if (!contract) {
    return { isValid: false, missingFields: ['Contract'] }
  }

  const missingFields: string[] = []

  // Check required contract fields
  if (!contract.salesOffice) {
    missingFields.push('Sales Office')
  }
  if (!contract.salesGroup) {
    missingFields.push('Sales Group')
  }
  if (!contract.paymentTerm) {
    missingFields.push('Payment Term')
  }
  if (!contract.cancellationProcedure) {
    missingFields.push('Cancellation Procedure')
  }

  return {
    isValid: missingFields.length === 0,
    missingFields
  }
}

// Initialize escalation flow from contract
export function initializeEscalationFromContract(
  offer: Offer,
  frontlineConfig: ClientFrontlineConfig
): Partial<Offer> {
  const contract = R.head(offer.opportunity.contracts || [])
  if (!contract) {
    return {}
  }

  const annualValue = getContractEquipmentsTotalAnnualValue(offer)

  // Get escalationMultiplier from renegotiation_refresh (new format)
  const optionC = frontlineConfig.renegotiation_refresh?.find(model => model.renegoModel === 'optionC')
  const escalationMultiplier = optionC?.escalationMultiplier || 10

  const isAlreadyEscalationFlow = offer.isEscalationFlow?.active === true
  const existingEscalatedPrice = offer.isEscalationFlow?.escalatedAnnualPrice || 0
  const existingEscalatedPercentage = offer.isEscalationFlow?.escalatedPercentage || 0
  const savedMultiplier = offer.isEscalationFlow?.escalationMultiplierSnapshot
  const preserveSavedPrice = existingEscalatedPrice > 0 &&
    (savedMultiplier == null || savedMultiplier === escalationMultiplier)

  const escalatedPrice = preserveSavedPrice
    ? existingEscalatedPrice
    : annualValue + (annualValue * escalationMultiplier / 100)

  const escalatedPercentage = preserveSavedPrice
    ? existingEscalatedPercentage
    : escalationMultiplier

  const result: Partial<Offer> = {
    isEscalationFlow: {
      active: true,
      rushContractType: contract.rushContractTypeCode,
      numberOfEquipments: contract.numberOfEquipments,
      initialContractAnnualPrice: annualValue,
      escalatedAnnualPrice: escalatedPrice,
      escalatedPercentage,
      escalationMultiplierSnapshot: escalationMultiplier,
      finalizedTotalPrice: calculateFinalizedTotalPrice(escalatedPrice, offer.commercialTerms),
      interimTotalPrice: escalatedPrice,
      escalationVasPrices: isAlreadyEscalationFlow ? offer.isEscalationFlow?.escalationVasPrices || 0 : 0,
      escalationVasDiscountedPercentage: isAlreadyEscalationFlow ? offer.isEscalationFlow?.escalationVasDiscountedPercentage || 0 : 0,
      escalationVasDiscountedPrices: isAlreadyEscalationFlow ? offer.isEscalationFlow?.escalationVasDiscountedPrices || 0 : 0,
    },
    isContractStartDateAtEquipmentLevel: false,
    isBillingPlanAtEquipmentLevel: false,
    isOrderReasonAtEquipmentLevel: false,
    assessmentMethod: 'grouped' as const,
    commercialTerms: populateCommercialTermsFromContract(offer)
  }

  return result
}

// Reset escalation flow. commercialTerms is intentionally left untouched - there is a single
// commercialTerms object per offer and any edits made during smart flow must be kept.
export function resetEscalationFlow(_offer: Offer): Partial<Offer> {
  return {
    priceEstimation: undefined,
    isEscalationFlow: {
      active: false,
      rushContractType: '',
      numberOfEquipments: 0,
      initialContractAnnualPrice: 0,
      escalatedAnnualPrice: 0,
      escalatedPercentage: 0,
      finalizedTotalPrice: 0,
      interimTotalPrice: 0,
      escalationVasPrices: 0,
      escalationVasDiscountedPercentage: 0,
      escalationVasDiscountedPrices: 0
    }
  }
}

// Update escalated price and recalculate
export function updateEscalatedPrice(
  offer: Offer,
  newPrice: number,
  escalationMultiplier: number
): Partial<Offer> {
  const annualValue = getContractEquipmentsTotalAnnualValue(offer)

  // Guard against division by zero
  // If contract has no annual value, treat the new price as 100% escalation from 0
  const newPercentage = annualValue > 0
    ? ((newPrice - annualValue) / annualValue) * 100
    : 0

  const updatedOffer = {
    ...offer,
    isEscalationFlow: {
      ...offer.isEscalationFlow,
      escalatedAnnualPrice: newPrice,
      escalatedPercentage: newPercentage,
      escalationMultiplierSnapshot: escalationMultiplier,
      finalizedTotalPrice: calculateFinalizedTotalPrice(newPrice, offer.commercialTerms),
      interimTotalPrice: newPrice,
      isEscalatedPriceManuallySet: true
    },
    prices: calculateEscalatedEquipmentPrices(offer, newPercentage)
  }

  return {
    ...updatedOffer,
    priceEstimation: resetOfferPriceEstimation(updatedOffer).priceEstimation
  }
}

// Fields shown in the EscalationCommercialTerms UI - kept in sync with that component
// Fields auto-populated from contract (VKBUR, VKGRP, ZTERM, VKUESCH) are trusted to be correct and not included
export const ESCALATION_COMMERCIAL_TERM_KEYS = ['VBEGDAT', 'VABNDAT', 'VAT', 'VAT_2', 'VAT_3', 'VLAUFK', 'KONDA', 'PROPORTIONAL_PRICE']

// Validate escalation commercial terms using the same rules as the CommercialTermsRow UI,
// so a field flagged invalid in the UI also blocks renewal.
export function validateEscalationCommercialTerms(
  offer: Offer,
  frontlineConfig: ClientFrontlineConfig
): { isValid: boolean; errors: Record<string, string> } {
  const escalationCommercialTermsConfig = (frontlineConfig.commercialTerms || []).filter(term =>
    ESCALATION_COMMERCIAL_TERM_KEYS.includes(term.key)
  )

  const errorKeys = getCommercialTermsErrors({
    commercialTermsConfig: escalationCommercialTermsConfig,
    selectedCommercialTerms: offer.commercialTerms,
    isContractStartDateAtEquipmentLevel: offer.isContractStartDateAtEquipmentLevel,
    isBillingModeApplied: false,
    isBillingPlanAtEquipmentLevel: false,
    isOrderReasonAtEquipmentLevel: false
  })

  const errors: Record<string, string> = Object.keys(errorKeys).reduce(
    (acc, key) => ({ ...acc, [key]: t(`commercialTerms:${key}.title`) }),
    {}
  )

  return {
    isValid: Object.keys(errors).length === 0,
    errors
  }
}

// Check if offer has been sent to SAP
export function offerHasSapContract(offer: Offer): boolean {
  return !!(offer.sapContractNumber && offer.sapContractNumber.length > 0)
}

// Contract renewal requires at least one contact with a role assigned
export function hasValidContactRoleForRenewal(offer: Offer): boolean {
  const errorIds = getOpportunityValidationErrors(offer).map(error => error.id)
  return !errorIds.includes('contact-missing-error') && !errorIds.includes('contact-missing-role-error')
}

// Validate price is not lower than contract value
export function validateEscalatedPrice(offer: Offer, newPrice: number): { isValid: boolean; error?: string } {
  const annualValue = getContractEquipmentsTotalAnnualValue(offer)

  if (newPrice < annualValue) {
    return {
      isValid: false,
      error: `Price cannot be lower than the original contract value (${annualValue})`
    }
  }

  return { isValid: true }
}

// Smart flow (escalation) offers have no equipment groups, build one entry covering all offer equipment instead
export function getEscalationOverviewGroupData(offer: Offer, totalPrice: number): OverviewGroupDetails | null {
  if (!offer.isEscalationFlow?.active) {
    return null
  }

  const toEquipmentPriceAndDetails = (
    equipment: Building['details']['equipment'][number]
  ): EquipmentPriceAndDetails => ({
    equipmentId: equipment.salesToolId,
    equipmentCategory: equipment.equipmentCategory,
    equipmentPrice: equipment.id ? getEscalationFlowEquipmentPrice(offer, equipment.id) : 0,
    buildingId: equipment.buildingId,
    inventoryNumber: equipment.inventoryNumber,
    year: equipment.year,
    koneEquipmentNumber: equipment.koneEquipmentNumber,
    manufacturer: equipment.manufacturer,
    equipmentProfile: {}
  })

  const allEquipment = offer.buildings?.flatMap(building => building.details.equipment) || []
  return {
    groupId: 'escalation-flow-overview',
    name: offer.opportunity.name,
    groupTotalPrice: totalPrice,
    elevators: allEquipment.filter(e => e.equipmentCategory === 'elevator').map(toEquipmentPriceAndDetails),
    escalators: allEquipment.filter(e => e.equipmentCategory === 'escalator').map(toEquipmentPriceAndDetails)
  }
}

